import $ from 'jquery'

$(document).on(
  'ajax:before',
  '[data-behaviour~="report-data-form"]',
  function () {
    const clonedInputs = $($(this).attr('data-target')).find('input').clone()
    const clonedInputsDiv = $('<div style="display:none"></div>').append(
      clonedInputs
    )

    $(this).empty()

    clonedInputsDiv.appendTo($(this))
    return true
  }
)

$(document).on(
  'keyup',
  '[data-behaviour~="report-data-sum-value"]',
  function (_) {
    const $form = $(this).closest(
      '[data-behaviour~="report-data-table-row-form"]'
    )

    let sum = 0.0

    $form.find('[data-behaviour~="report-data-sum-value"]').each(function () {
      const val = $(this).val()
      if (val) {
        sum += parseFloat(val.replace(',', '.'))
      }
    })

    $form.find('[data-behaviour~="report-data-value"]').val(sum.toFixed(2))
  }
)

$(document).on(
  'keyup',
  '[data-behaviour~="report-data-table-row-form"]',
  function (e) {
    if (e.which === 13) {
      const $form = $(this).find('form')

      $(this)
        .find('input')
        .each(function (index, object) {
          const $object = $(object)

          if (!$object.prop('form')) {
            $form.find(`[name='${$object.attr('name')}']`).val($object.val())
          }
        })

      $form.submit()
    }
  }
)
